export default {
      id: "pause-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#pause",
      toString: function () {
        return this.url;
      }
    }